// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__23os_","title":"InfoRow_title__1nv4-"};